import type { App } from "vue";
import type { HotjarQueueFunction, HotjarSettings } from "@/core/types/index";

const HotjarPlugin = {
  install(_: App, options: Partial<HotjarSettings> = {}): void {
    const siteId: number | null = import.meta.env.VITE_APP_HOTJAR_SITE_ID
      ? Number(import.meta.env.VITE_APP_HOTJAR_SITE_ID)
      : null;
    const snippetVersion: number | null = import.meta.env
      .VITE_HOTJAR_SNIPPET_VERSION
      ? Number(import.meta.env.VITE_APP_HOTJAR_SNIPPET_VERSION)
      : null;

    if (!siteId && !snippetVersion) return;

    const hjid = Number(siteId);
    const hjsv = options.hjsv ?? snippetVersion ?? 6;

    if (!window.hj) {
      const hj: HotjarQueueFunction & { q?: unknown[][] } = (...args) => {
        (hj.q = hj.q || []).push(args);
      };
      window.hj = hj;
    }

    window._hjSettings = { hjid, hjsv, ...options };

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://static.hotjar.com/c/hotjar-${hjid}.js?sv=${hjsv}`;
    document.head.appendChild(script);
  },
};

export default HotjarPlugin;
